export default function TabbedCarousel() {
    document.addEventListener('DOMContentLoaded', () => {
        document.querySelectorAll('.tabbed-carousel').forEach((element) => {
            new TabbedCarouselInstance(element);
        });
    });
}

class TabbedCarouselInstance {
    constructor(element) {
        this.element = element;

        this.handleClick = this.handleClick.bind(this);
        this.element.addEventListener('click', this.handleClick);
    }

    handleClick(event) {
        const button = event.target.closest('button[data-carousel-id]');
        if (!button || !this.element.contains(button)) {
            return;
        }

        const matchingDetail = this.element.querySelector(`details[data-carousel-id="${button.dataset.carouselId}"]`);
        if (!matchingDetail) {
            return;
        }

        this.element.querySelector('button.active').classList.remove('active');
        button.classList.add('active');

        matchingDetail.open = true;
    }
}